import { Form, Input, Select, Button, InputNumber, notification } from "antd";
import { HomeOutlined, NumberOutlined, DollarOutlined } from "@ant-design/icons";
import { useGetBranchesQuery } from "../../services/branches";
import { useAddLockerMutation } from "../../services/lockers";
import PageBreadcrumb from "../../components/breadcrumb";
import { AllLockersRoute, Home } from "../../routes/routepath";
import { useNavigate } from "react-router-dom";
import "./styles.scss";

/* ─── Constants ──────────────────────────────────────────────────────── */

const breadcrumbItems = [
  { label: <HomeOutlined />, to: Home },
  { label: "All Lockers", to: AllLockersRoute },
  { label: "Add Locker" },
];

/* ─── Component ──────────────────────────────────────────────────────── */

const AddLocker = () => {
  const navigate = useNavigate();
  const [form]   = Form.useForm();

  const { data: branchesData, isLoading: branchesLoading } = useGetBranchesQuery(undefined);
  const [addLocker, { isLoading: saving }] = useAddLockerMutation();

  const onFinishFailed = ({ errorFields }: { errorFields: { name: (string | number)[]; errors: string[] }[] }) => {
    if (!errorFields?.length) return;
    const labels = errorFields.map(f => {
      const name = Array.isArray(f.name) ? f.name[0] : f.name;
      return String(name).replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    });
    notification.error({
      message:     'Required Fields Missing',
      description: [...new Set(labels)].join(', '),
      placement:   'topRight',
      duration:    4,
    });
  };

  const onFinish = async (values: Record<string, any>) => {
    const payload = {
      lockerNumber:  values.lockerNumber,
      branchId:      values.branch,
      price:         values.price ?? 0,
    };
    try {
      await (addLocker as any)(payload).unwrap();
      notification.success({ message: "Locker added successfully", placement: "topRight" });
      form.resetFields();
      navigate(AllLockersRoute);
    } catch (error) {
      console.error('Add locker error:', error);
      notification.error({ message: "Failed to add locker", placement: "topRight" });
    }
  };

  return (
    <div className="add-locker-page">
      <div className="form-header">
        <h2>Add Locker</h2>
        <PageBreadcrumb items={breadcrumbItems} />
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed} className="custom-form">
        <div className="row">
          <Form.Item name="branch" label="Branch" rules={[{ required: true, message: 'Please select branch' }]}>
            <Select
              placeholder="Select branch"
              loading={branchesLoading}
              showSearch
              options={(branchesData as any)?.data?.map((b: any) => ({ label: b.name, value: b._id })) || []}
            />
          </Form.Item>

          <Form.Item name="lockerNumber" label="Locker Number" rules={[{ required: true, message: 'Please enter locker number' }]}>
            <Input placeholder="e.g. L-01" prefix={<NumberOutlined />} />
          </Form.Item>
        </div>

        <div className="row">
          <Form.Item name="price" label="Price">
            <InputNumber
              min={0}
              style={{ width: '100%' }}
              placeholder="Enter price"
              formatter={(v) => `${v ?? ''}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={((v: string) => v ? v.replace(/,/g, '') : '') as any}
              prefix={<DollarOutlined />}
            />
          </Form.Item>
        </div>

        <div className="footer-buttons">
          <Button className="save-btn" htmlType="submit" loading={saving}>
            Save Locker
          </Button>
         
        </div>
      </Form>
    </div>
  );
};

export default AddLocker;
